import React, { Component } from 'react';
import './Checkbox.scss';

class Checkbox extends Component {
  constructor() {
    super();
    this.state = {
      hovering: false,
    };
  }

  toggleHover = () => {
    this.setState((state) => ({ hovering: !state.hovering }));
  };

  render() {
    const { hovering } = this.state;
    const {
      children,
      id,
      name,
      checked = false,
      handleChange,
      wrapperClass,
      tooltip,
    } = this.props;

    return (
      <div
        className={wrapperClass}
        onMouseEnter={tooltip ? this.toggleHover : null}
        onMouseLeave={tooltip ? this.toggleHover : null}
      >
        <input
          tabIndex={0}
          type="checkbox"
          name={name}
          id={id}
          checked={!!checked}
          onChange={handleChange}
        />
        {children}
        {hovering && !checked && <span className="tooltip">{tooltip}</span>}
      </div>
    );
  }
}

export default Checkbox;
